import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { selectIsInitialStateModified } from '../../../reducers/community-settings/registrationAccessCodeReducer'
import SubmitButton from '../../common/buttons/SubmitButton'

import classes from './AccessCodeFooter.module.scss'

const AccessCodeFooter = () => {
  const isInitialStateModified = useSelector(selectIsInitialStateModified)
  const isLoading = useSelector(state => state.communitySettings.accessCodePage.isLoading)

  return (
    <div className={classNames('d-flex justify-content-center align-items-center', classes.accessCodeFooter)}>
      <SubmitButton
        noTopMargin
        disabled={!isInitialStateModified || isLoading}
        loading={isLoading}
        className={classNames(classes['save-button'])}
        buttonMessage='Save Changes'
        form='accessControl'
        iconType={isLoading ? 'loadingSpinner' : ''}
      />
    </div>
  )
}

export default AccessCodeFooter
